import { KeyRound, ShieldCheck } from "lucide-react";
import { useState, type FormEvent } from "react";
import { Toast, type ToastMessage } from "../components/Toast";
import { api } from "../lib/api";
import { useAuth } from "../auth/AuthContext";

export function AccountPage() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [toast, setToast] = useState<ToastMessage | null>(null);

  async function changePassword(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    const form = event.currentTarget;
    const values = new FormData(form);
    const currentPassword = String(values.get("currentPassword"));
    const newPassword = String(values.get("newPassword"));
    const confirmation = String(values.get("confirmation"));
    if (newPassword !== confirmation) {
      setToast({ kind: "error", text: "The new passwords do not match." });
      setBusy(false);
      return;
    }
    try {
      await api("/api/v1/auth/change-password", {
        method: "POST",
        body: JSON.stringify({ currentPassword, newPassword }),
      });
      form.reset();
      setToast({ kind: "success", text: "Password changed. Other signed-in sessions were ended." });
    } catch (caught) {
      setToast({ kind: "error", text: caught instanceof Error ? caught.message : "Could not change the password." });
    } finally {
      setBusy(false);
    }
  }

  return <div className="page-stack account-page">
    <section className="panel account-panel account-identity"><span className="eyebrow">Signed in as</span><h2>{user?.displayName}</h2><p>{user?.email}</p><span className="status-chip confirmed">{user?.role}</span></section>
    <section className="panel account-panel">
      <header className="panel-header"><div><span className="eyebrow">Account security</span><h3>Change your password</h3></div><span className="setting-icon"><ShieldCheck /></span></header>
      <p className="panel-note">Use at least 12 characters. Changing the password signs this account out of other browser sessions.</p>
      <form className="modal-form account-form" onSubmit={changePassword}>
        <label className="field full"><span>Current password</span><input name="currentPassword" type="password" autoComplete="current-password" required /></label>
        <label className="field full"><span>New password</span><input name="newPassword" type="password" minLength={12} maxLength={128} autoComplete="new-password" required /></label>
        <label className="field full"><span>Confirm new password</span><input name="confirmation" type="password" minLength={12} maxLength={128} autoComplete="new-password" required /></label>
        <button className="button button-primary" disabled={busy}><KeyRound size={18} />{busy ? "Changing…" : "Change password"}</button>
      </form>
    </section>
    {toast && <Toast message={toast} onClose={() => setToast(null)} />}
  </div>;
}
